import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
export function getType(value) {
  return Object.prototype.toString.call(value).replace(/^\[object |]$/gi, '');
}